import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CustomerAccount } from './customer-account.model';

import * as ACTIONS from './customer-accounts.actions';
import * as SELECTORS from './customer-accounts.selectors';

@Injectable()
export class CustomerAccountsFacade {
    selectedAccount$: Observable<CustomerAccount | null> = this.store.select(SELECTORS.getSelectedCustomerAccount);
    loading$: Observable<boolean> = this.store.select(SELECTORS.customerAccountsLoading);
    allAccountDataLoading$: Observable<boolean> = this.store.select(SELECTORS.allAccountDataLoading);
    accountsWithDisplayData$ = this.store.select(SELECTORS.getAccountsWithDisplayData);
    selectedAccountWithDisplayData$ = this.store.select(SELECTORS.getSelectedAccountWithDisplayData);
    accountSelectorUIState$ = this.store.select(SELECTORS.getAccountSelectorUIState);

    constructor(private store: Store) {}

    fetchCustomerAccounts(): void {
        this.store.dispatch(ACTIONS.fetchCustomerAccounts());
    }

    selectCustomerAccount(accountId: string): void {
        this.store.dispatch(ACTIONS.selectCustomerAccount({ accountId }));
    }

    clearSelectedAccount(): void {
        this.store.dispatch(ACTIONS.clearSelectedCustomerAccount());
    }
}
